var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component_divisions"},[_c('ul',_vm._l((_vm.menuLinks),function(menuLink){return _c('li',{key:menuLink.title,class:{
        highlight: _vm.highlighted === menuLink.title,
        hidden: menuLink.hidden,
      },on:{"click":function($event){return _vm.activate(menuLink)}}},[_c('MenuComponentLink',{attrs:{"menuLink":menuLink}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }